import moment from 'moment'

export const PROBLEM_KINDS = [
  {
    kind: 'paid_not_applied',
    title: 'Оплачено, но не применено',
    hint: 'ЮKassa приняла деньги, а участник или заказ не отмечены оплаченными',
    variant: 'danger',
  },
  {
    kind: 'processed_entity_unpaid',
    title: 'Обработан, но не оплачен',
    hint: 'Платёж помечен обработанным, а регистрация или заказ не оплачены',
    variant: 'danger',
  },
  {
    kind: 'unresolved_entity',
    title: 'Неизвестно, за что платёж',
    hint: 'Платёж не привязан к регистрации, заказу или донату',
    variant: 'danger',
  },
  {
    kind: 'declined',
    title: 'Отклонён обработчиком',
    hint: 'Уведомление пришло, но обработчик не применил платёж',
    variant: 'danger',
  },
  {
    kind: 'possible_duplicates',
    title: 'Возможные дубли',
    hint: 'Регистрация уже оплачена другой попыткой — вероятно, человек заплатил дважды',
    variant: 'warning',
  },
  {
    kind: 'wallet_pending',
    title: 'Часть кошельком не подтверждена',
    hint: 'Платёж применён, а списание с кошелька так и осталось в ожидании',
    variant: 'warning',
  },
  {
    kind: 'stale_pending',
    title: 'Зависшие',
    hint: 'Платёж не завершён больше часа',
    variant: 'warning',
  },
  {
    kind: 'unmatched_webhooks',
    title: 'Уведомления без платежа',
    hint: 'Пришло уведомление от ЮKassa, а такого платежа у нас нет',
    variant: 'secondary',
  },
]

export const TYPE_LABELS = {
  start: 'Регистрация на старт',
  shop: 'Магазин',
  donation: 'Донат',
  virtualTopUp: 'Пополнение кошелька',
}

export const ENTITY_LABELS = {
  start_group: 'Регистрация',
  order: 'Заказ',
  donation: 'Донат',
  wallet_top_up: 'Кошелёк',
}

/** What a payment of a type can be linked to by hand */
export const LINKABLE_ENTITY = {
  start: 'start_group',
  shop: 'order',
  donation: 'donation',
}

export const SEVERITY_VARIANTS = {
  error: 'danger',
  warning: 'warning',
  info: 'info',
}

export const ACTION_LABELS = {
  reapply: 'Применить платёж',
  link_entity: 'Привязать к записи',
  recheck: 'Перепроверить в ЮKassa',
  refund: 'Вернуть деньги вручную (в кабинете ЮKassa)',
}

export const EVENT_LEVEL_VARIANTS = {
  error: 'danger',
  warn: 'warning',
  info: 'info',
  debug: 'secondary',
}

export function statusVariant(status) {
  if (status === 'succeeded') return 'success'
  if (status === 'canceled') return 'secondary'
  if (status === 'waiting_for_capture') return 'info'
  if (status === 'pending') return 'warning'
  return 'light'
}

export function formatMoney(kopecks) {
  if (kopecks === null || kopecks === undefined) return '—'
  return (kopecks / 100).toLocaleString('ru-RU', { style: 'currency', currency: 'RUB' })
}

export function formatDate(value) {
  return value ? moment(value).format('DD.MM.YYYY HH:mm:ss') : '—'
}

export function errorMessage(error, fallback = 'Не удалось выполнить запрос') {
  const data = error && error.response && error.response.data
  if (!data) return (error && error.message) || fallback
  return data.message || data.error || fallback
}
